// ── database.ts — Barrel file ──
// All logic lives in db/ modules. This file re-exports as supabaseDb for backward compat.
import { getAvailableRestaurants, getRestaurantDetail, updateRestaurant, updateBillingOnly, getRestaurantBySlug } from './db/restaurants';
import { updateProfile } from './db/profiles';
import { createMenuBackup, saveFullMenu, getRestaurantMenu } from './db/menu';

export const supabaseDb = {
  getAvailableRestaurants,
  getRestaurantDetail,
  updateRestaurant,
  updateBillingOnly,
  updateProfile,
  getRestaurantBySlug,
  createMenuBackup,
  saveFullMenu,
  getRestaurantMenu
};
